import React from 'react';
import { HeroSection } from './HeroSection';
import { IncludesSection } from './IncludesSection';
import { PainPoints } from './PainPoints';
import { SolutionSection } from './SolutionSection';
import { BonusSection } from './BonusSection';
import { TestimonialsSection } from './TestimonialsSection';
import { PurchaseSection } from './PurchaseSection';
import { PurchasePopup } from './PurchasePopup';
import { CountdownBar } from './CountdownBar';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden" data-id="element-140">
      <CountdownBar data-id="element-141" />
      <div className="pt-10" data-id="element-142">
        <HeroSection data-id="element-143" />
        <IncludesSection data-id="element-144" />
        <PainPoints data-id="element-145" />
        <SolutionSection data-id="element-146" />
        <BonusSection data-id="element-147" />
        <TestimonialsSection data-id="element-148" />
        <PurchaseSection data-id="element-149" />
      </div>
      <PurchasePopup data-id="element-150" />

      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm" data-id="element-151">
        <p data-id="element-152">
          © {new Date().getFullYear()} Mega Pack de Intervención
          Fonoaudiológica Infantil. Todos los derechos reservados.
        </p>
      </footer>
    </div>;
}